function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobothead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M72 120h48c6.617 0 12-5.383 12-12V96H60v12c0 6.617 5.383 12 12 12zm12-8v-8h8v8h-8zm16-8h8v8h-8v-8zm24 4c0 2.206-1.794 4-4 4h-4v-8h8v4zm-56-4h8v8h-4c-2.206 0-4-1.794-4-4v-4zm6-20c7.72 0 14-6.28 14-14s-6.28-14-14-14-14 6.28-14 14 6.28 14 14 14zm0-20c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zm102 24c0-11.87-8.664-21.75-20-23.66V40h-56v-9.079A7.99 7.99 0 0 0 104 24a8 8 0 0 0-16 0 7.99 7.99 0 0 0 4 6.921V40H36v24.34C24.664 66.25 16 76.13 16 88s8.664 21.75 20 23.66V136h32v16H36v24h120v-24h-36v-16h36v-24.34c11.336-1.91 20-11.79 20-23.66zM24 88c0-7.439 5.11-13.69 12-15.473v30.946C29.11 101.69 24 95.44 24 88zm124 72v8H44v-8h104zm-36-8H76v-16h36v16zm36-24H44V48h104v80zm8-24.527V72.527c6.89 1.783 12 8.034 12 15.473s-5.11 13.69-12 15.473zM118 84c7.72 0 14-6.28 14-14s-6.28-14-14-14-14 6.28-14 14 6.28 14 14 14zm0-20c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobothead);
export default __webpack_public_path__ + "static/media/robothead.4ce7845139a7c57b1b0e67e8517171d5.svg";
export { ForwardRef as ReactComponent };